import classNames from 'styles/utils/classNames';

interface AddInfoBtnProps {
  label: string;
  onClick: () => void;
  className?: string;
}

const AddInfoBtn: React.FC<AddInfoBtnProps> = ({ label, onClick, className }) => {
  return (
    <button
      className={classNames(
        'typography-product-button-label-small mt-4 flex w-full items-center justify-center rounded-md border border-color-border-input-lightmode bg-color-bg-lightmode-tertiary px-2 py-3 text-color-brand-primary dark:border-color-border-input-darkmode dark:bg-color-bg-darkmode-tertiary',
        className,
      )}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

export default AddInfoBtn;
